// extracted by mini-css-extract-plugin
export default {"renewBtn":"layout_renewBtn__dPiH+"};